export default __webpack_public_path__ + "static/media/teacher2.04f18f0e.jpg";